import { useContext } from 'react'

import { I18NContext } from '../contexts/I18NContextProvider'

export const useI18N = () => useContext( I18NContext )